__turbopack_context__.v({
  "arrowImg": "MultiSelect-module-scss-module__qYR8zq__arrowImg",
  "content": "MultiSelect-module-scss-module__qYR8zq__content",
  "empty": "MultiSelect-module-scss-module__qYR8zq__empty",
  "emptyInput": "MultiSelect-module-scss-module__qYR8zq__emptyInput",
  "error": "MultiSelect-module-scss-module__qYR8zq__error",
  "expandLine": "MultiSelect-module-scss-module__qYR8zq__expandLine",
  "input": "MultiSelect-module-scss-module__qYR8zq__input",
  "label": "MultiSelect-module-scss-module__qYR8zq__label",
  "noResults": "MultiSelect-module-scss-module__qYR8zq__noResults",
  "option": "MultiSelect-module-scss-module__qYR8zq__option",
  "options": "MultiSelect-module-scss-module__qYR8zq__options",
  "optionsWrapper": "MultiSelect-module-scss-module__qYR8zq__optionsWrapper",
  "removeOption": "MultiSelect-module-scss-module__qYR8zq__removeOption",
  "root": "MultiSelect-module-scss-module__qYR8zq__root",
  "searchWrapper": "MultiSelect-module-scss-module__qYR8zq__searchWrapper",
  "selected": "MultiSelect-module-scss-module__qYR8zq__selected",
  "selectedOption": "MultiSelect-module-scss-module__qYR8zq__selectedOption",
  "selectedOptions": "MultiSelect-module-scss-module__qYR8zq__selectedOptions",
});
